/**
 * pager.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { Paginated, PaginationPipe } from "./pipes/paginate.pipe";

/**
 * The {@link PagerComponent} provides pagination buttons that link to the
 * {@link Paginated} interface's values and methods (which are autogenerated by
 * participation in the {@link PaginationPipe}). It's generally assumed that
 * the pager is always used in tandem with the "paginate" pipe, for example:
 *
 * <repeat-element *ngFor="let item of TARGET_ARRAY | paginate">
 *  <!-- content -->
 * </repeat-element>
 * <!-- ... -->
 * <pager [array]="TARGET_ARRAY"></pager>
 */
@Component({
  selector: `pager`,
  template: `
    <nav *ngIf="!asNeeded || (array._maxPage > 1)">
      <ul class="pager">
        <li
          *ngIf="jumpButtons"
          class="previous"
          [class.disabled]="array._pageIndex <= 0">
          <a (click)="array._goto(0)">First</a>
        </li>
        <li
          class="previous"
          [class.disabled]="array._pageIndex <= 0">
          <a (click)="array._previous()">
            Previous
          </a>
        </li>
        <li class="text-center">
          <strong>
            Page {{array._pageIndex + 1}} of {{array._maxPage}}
          </strong>
        </li>
        <!-- note: the "last" button occurs first because it's pulled right -->
        <li
          *ngIf="jumpButtons"
          class="next"
          [class.disabled]="array._pageIndex >= array._maxPage - 1">
          <a (click)="array._goto(-1)">Last</a>
        </li>
        <li
          class="next"
          [class.disabled]="array._pageIndex >= array._maxPage - 1">
          <a (click)="array._next()">Next</a>
        </li>
      </ul>
    </nav>
  `,
  styles: [`
    nav {
        font-size: medium;
        font-style: normal;
        color: #333;
    }
    .pager {margin: 0;}
  `]
})
export class PagerComponent implements OnInit
{
  /**
   * The array to read pagination metadata from (although strictly speaking, the
   * Paginated interface doesn't need to be on an array, but the current usage
   * implies it).
   */
  @Input()
  public array : Paginated;

  /**
   * Whether to show "first" & "last" buttons that jump directly to those pages.
   */
  @Input()
  public jumpButtons : boolean = false;

  /**
   * Whether to hide the buttons if the content is 1 page or less.
   */
  @Input()
  public asNeeded : boolean = false;

  public ngOnInit () : void
  {
    // 🦆🦆🦆
    if (Array.isArray(this.array) && !Number.isInteger(this.array._maxPage))
    {
      console.warn("Pager array does not appear to have pagination metadata!");
      // If we manage to run before the paginator, manually call the pipe's
      // annotator method to generate the page metadata.
      PaginationPipe.updatePagination(this.array);
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pager.component.ts